module.exports = __webpack_public_path__ + "static/educatorCopy-70d65f4355163d32587003bb0cb63801.png";